import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const channelDeleteApi = createAsyncThunk(
  "auth/channel/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.delete(apiRoutes.channelAction('delete',1,id,1));
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const channelDeleteSlice = createSlice({
  name: "channel delete",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(channelDeleteApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(channelDeleteApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(channelDeleteApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const channelDeleteReducer = channelDeleteSlice.reducer;
